import { toast } from 'App';
import { isAxiosError } from 'axios';
import { verificationStore } from 'views/store/useVerificationStore';
import { $api } from './interceptor';
import { TPendingVerification } from 'views/types/pendingVerification';

type TParams = {
  page?: number;
  limit?: number;
  search?: string;
};

type TMetadata = {
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
};

const verificationApi = () => {
  const getVerificationItems = async (params: TParams = {}) => {
    try {
      verificationStore.setState({ loading: true });
      const { data } = await $api.get<{
        data: TPendingVerification[];
        meta: TMetadata;
      }>('/api/kyc', {
        params,
      });
      verificationStore.setState({ kysItem: data.data });
      return data;
    } catch (error) {
      errorHandler(error);
      verificationStore.setState({ kysItem: [] });
    } finally {
      verificationStore.setState({ loading: false });
    }
  };

  const approveVerification = async (id: string) => {
    try {
      verificationStore.setState({ loading: true });
      await $api.post('/api/kyc/approve', {
        id,
      });

      pushSuccessToast('KYC verification was successfully approved!');
      verificationStore.setState(state => ({
        kysItem: state.kysItem.filter(item => item.id !== id),
      }));

      return true;
    } catch (error) {
      errorHandler(error);
      return false;
    } finally {
      verificationStore.setState({ loading: false });
    }
  };

  const pushSuccessToast = (message: string) => {
    toast({
      title: 'Success',
      description: message,
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'top-right',
    });
  };

  const errorHandler = (error: unknown) => {
    console.error(error);

    let description = 'Something went wrong. Please try again later.';

    if (isAxiosError(error)) {
      const responseMessage = error.response?.data?.message;

      if (typeof responseMessage === 'string') {
        description = responseMessage;
      } else if (Array.isArray(responseMessage)) {
        description = responseMessage.join(', ');
      }
    }

    toast({
      title: 'Error',
      description,
      status: 'error',
      duration: 3000,
      isClosable: true,
      position: 'top-right',
    });
  };

  return { getVerificationItems, approveVerification };
};

export const verificationService = verificationApi();
